module.exports = __webpack_public_path__ + "static/media/pla_clear_gaint_straw1.6892c3f8.png";